import React from "react";
import { Helmet } from "react-helmet";

interface Props {
    value: string;
}

const HtmlFacebookAppId: React.SFC<Props> = ({ value }) => (
    <Helmet>
        <meta property="fb:app_id" content={value} />
    </Helmet>
);

export default HtmlFacebookAppId;
